import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-currencyeth",
  "use": "icon-th-currencyeth-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-currencyeth\">\n<path d=\"M27.7862 15.3826L16.7862 1.38258C16.6927 1.26352 16.5733 1.16726 16.4371 1.10107C16.3009 1.03488 16.1514 1.00049 16 1.00049C15.8486 1.00049 15.6991 1.03488 15.5629 1.10107C15.4267 1.16726 15.3073 1.26352 15.2137 1.38258L4.21373 15.3826C4.07546 15.5587 4.00031 15.7762 4.00031 16.0001C4.00031 16.224 4.07546 16.4414 4.21373 16.6176L15.2137 30.6176C15.3073 30.7366 15.4267 30.8329 15.5629 30.8991C15.6991 30.9653 15.8486 30.9997 16 30.9997C16.1514 30.9997 16.3009 30.9653 16.4371 30.8991C16.5733 30.8329 16.6927 30.7366 16.7862 30.6176L27.7862 16.6176C27.9245 16.4414 27.9997 16.224 27.9997 16.0001C27.9997 15.7762 27.9245 15.5587 27.7862 15.3826ZM17 4.89133L25.4275 15.6163L17 19.4476V4.89133ZM15 19.4476L6.57248 15.6163L15 4.89133V19.4476ZM15 21.6438V27.1088L8.32123 18.6088L15 21.6438ZM17 21.6438L23.6787 18.6076L17 27.1076V21.6438Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-currencyeth.svg
// module id = apZl
// module chunks = 83